<template>
  <Head title="Manage Proposal" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <manage-proposal
            :initial-clients="clients"
            :initial-agencies="agencies"
            :proposal-data="proposal"
          />
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../../Layouts/AppLayout.vue';

defineProps({
  clients: Array,
  agencies: Array,
  proposal: {
    type: Object,
    default: null
  }
});
</script>

